<template>
  <div class="print-template-editor">
    <a-modal title="添加模板" :visible="visible" :confirmLoading="loading" @ok="handleSubmit" @cancel="handleClose">
      <a-form-model ref="form" :model="form" :rules="rules" :label-col="{ span: 4 }" :wrapper-col="{ span: 18 }">
        <a-form-model-item label="模板名称" prop="name">
          <a-input v-model="form.name" placeholder="请输入模板名称" />
        </a-form-model-item>
        <a-form-model-item label="模板文件" prop="file">
          <a-upload name="file" :action="uploadUrl" :beforeUpload="beforeUpload" :fileList="fileList"
            @change="handleFileChange">
            <a-button>
              <a-icon type="upload" /> 选择文件
            </a-button>
            <div class="ant-upload-hint">
              请上传 FastReport 模板文件（.frx）
            </div>
          </a-upload>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
import request from '@/utils/request'
import { API, BASE_URL } from '@/config/api'

export default {
  name: 'PrintTemplateEditor',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    platform: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      loading: false,
      form: {
        name: '',
        file: undefined
      },
      fileList: [],
      rules: {
        name: [
          { required: true, message: '请输入模板名称', trigger: 'blur' },
          { min: 2, max: 50, message: '长度在 2 到 50 个字符', trigger: 'blur' }
        ],
        file: [
          { required: true, message: '请上传模板文件', trigger: 'change' }
        ]
      }
    }
  },
  computed: {
    uploadUrl() {
      return BASE_URL + API.UPLOAD
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.initForm()
      } else {
        this.fileList = []
      }
    }
  },
  methods: {
    initForm() {
      this.form = {
        name: '',
        file: undefined
      }
      this.fileList = []
      // 重置表单验证
      this.$nextTick(() => {
        this.$refs.form?.clearValidate()
      })
    },
    handleClose() {
      this.$emit('update:visible', false)
      this.$emit('close')
    },
    beforeUpload(file) {
      // 检查文件类型
      const isFrxFile = file.name.toLowerCase().endsWith('.frx')
      if (!isFrxFile) {
        this.$message.error('只能上传 FastReport 模板文件（.frx）！')
        return false
      }
      // 检查文件大小
      const isLt10M = file.size / 1024 / 1024 < 10
      if (!isLt10M) {
        this.$message.error('文件必须小于 10MB！')
        return false
      }
      return true
    },
    handleFileChange(info) {
      let fileList = [...info.fileList]
      // 限制只能上传一个文件
      fileList = fileList.slice(-1)

      // 更新上传状态
      fileList = fileList.map(file => {
        if (file.response) {
          file.url = file.response.data.fullurl
        }
        return file
      })

      this.fileList = fileList

      // 处理上传完成后的响应
      if (info.file.status === 'done') {
        if (info.file.response.code === 1) {
          this.form.file = info.file.response.data.url
          this.$message.success('文件上传成功')
        } else {
          this.$message.error(info.file.response.msg || '文件上传失败')
        }
      } else if (info.file.status === 'error') {
        this.$message.error('文件上传失败')
      }
    },
    handleSubmit() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          this.loading = true
          try {
            const params = {
              platform: this.platform,
              name: this.form.name,
              file_path: this.form.file
            }
            const res = await request.post(API.PRINT_TEMPLATE_ADD, params)
            if (res.code === 1) {
              this.$message.success('添加成功')
              this.$emit('success')
              this.handleClose()
            } else {
              this.$message.error(res.msg || '添加失败')
            }
          } catch (error) {
            this.$message.error(error.message || '添加失败')
          } finally {
            this.loading = false
          }
        }
      })
    }
  }
}
</script>

<style scoped>
.print-template-editor {
  .ant-form-item {
    margin-bottom: 16px;
  }

  .ant-upload-hint {
    margin-top: 8px;
    color: rgba(0, 0, 0, 0.45);
  }
}
</style>